import React, { useContext, useEffect } from 'react';
import { getAppEnv } from '../../../../config/env';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../CabsLandingContext';
import { SET_HR_PACKAGE, SET_WIDGET } from '../cabsLandingPageState';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const RentalPackages = ({ style }) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);
  const { trackTemplateEvent } = cabsLandingContext;

  const { packages, selectedHrPackage } = cabsLandingContext;

  const closePopup = () => {
    dispatch && dispatch({ type: SET_WIDGET, newStateValue: null });
  };

  const setSelectedHrPackage = hrPackage => {
    dispatch && dispatch({ type: SET_HR_PACKAGE, newStateValue: hrPackage });
    trackTemplateEvent(
      `Mob_Cabs_Landing_HR_Package_Bottomsheet_${hrPackage.package_id}_Select`
    );
  };

  const isSelectedPackage = hrPackage => {
    if (!hrPackage) return false;
    return hrPackage.package_id == selectedHrPackage?.package_id;
  };

  return (
    <div
      id="hrPackageBottomSheet"
      style={{
        position: 'fixed',
        width: '100%',
        bottom: '0px',
        left: '0px',
        paddingBottom: 20,
        backgroundColor: '#ffffff',
        zIndex: 10
      }}
    >
      <div>
        <div
          className="makeFlex"
          style={{
            padding: '15px 16px',
            boxShadow: 'rgba(0, 0, 0, 0.2) 0px 3px 1.5px'
          }}
        >
          <img
            onClick={closePopup}
            className="appendRight20"
            src={`${PUBLIC_URL}/static/public/close_grey.webp`}
            height={'24px'}
            width={'24px'}
            alt="logo"
          />
          <div className="latoBold blackText font18 makeFlex vrtlCenter2">
            {' '}
            Select Package
          </div>
        </div>
        <div>
          {packages &&
            packages.map(hrPackage => {
              return (
                <div
                  className="makeFlex"
                  style={{ margin: '20px 16px' }}
                  onClick={() => {
                    setSelectedHrPackage(hrPackage);
                    closePopup();
                  }}
                >
                  {isSelectedPackage(hrPackage) ? (
                    <span className={`${style.circleOuter}`}>
                      <span className={`${style.activeCircleInner}`}></span>
                    </span>
                  ) : (
                    <span className={style.circleOuter}>
                      <span className={style.circleInner}></span>
                    </span>
                  )}
                  <div
                    className={
                      isSelectedPackage(hrPackage)
                        ? 'latoBlack greyishBlackText font16 makeFlex vrtlCenter2'
                        : 'latoRegular font16 makeFlex vrtlCenter2'
                    }
                  >
                    {`${hrPackage.time} hrs ${hrPackage.distance} kms`}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div></div>
    </div>
  );
};
